"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_bootstrap_table2_toolkit_1 = require("react-bootstrap-table2-toolkit");
var react_bootstrap_table_next_1 = require("react-bootstrap-table-next");
var react_bootstrap_table2_paginator_1 = require("react-bootstrap-table2-paginator");
var Components_1 = require("../../../../../Components");
var Types_1 = require("../Types");
var ReportsTable = /** @class */ (function (_super) {
    __extends(ReportsTable, _super);
    function ReportsTable(props) {
        var _this = _super.call(this, props) || this;
        _this.onTableChange = function (type, newState) {
            _this.setState({ tableState: newState });
            _this.props.tableChangeHandler(newState.page, newState.sizePerPage);
        };
        _this.tableRef = React.createRef();
        _this.state = {
            tableState: {
                sizePerPage: 10,
                page: 1
            }
        };
        return _this;
    }
    ReportsTable.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_bootstrap_table2_toolkit_1.default, { keyField: "id", data: this.props.data, columns: Types_1.ReportsTableColumns(this.props.resources) }, function (props) { return (React.createElement("div", null,
            React.createElement(react_bootstrap_table_next_1.default, __assign({}, props.baseProps, { bootstrap4: true, condensed: true, hover: _this.props.data.length > 0, noDataIndication: function () { return _this.props.pending ? React.createElement(Components_1.CustomSpinner, null) : React.createElement("div", null, _this.props.resources.NoData); }, remote: {
                    filter: false,
                    pagination: true,
                    sort: false,
                    cellEdit: false
                }, ref: _this.tableRef, onTableChange: _this.onTableChange, bordered: false, keyField: "id", defaultSorted: Types_1.ReportsTableDefaultSort, pagination: _this.props.usePagination ? react_bootstrap_table2_paginator_1.default({ page: _this.props.page, totalSize: _this.props.totalSize, paginationSize: 1, withFirstAndLast: false, sizePerPageRenderer: _this.props.exportRenderer }) : undefined, expandRow: _this.props.expandRow })))); }));
    };
    return ReportsTable;
}(React.Component));
exports.ReportsTable = ReportsTable;
//# sourceMappingURL=ReportsTable.js.map